export const embedUrl = (link, autoplay, loop) => {
	if (typeof autoplay == "undefined")
		autoplay = true;
	if (typeof loop == "undefined")
		loop = false;

	var pattern0 = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/(.+)\/(.+)/g;
	var pattern1 = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g;
	var pattern2 = /(?:http?s?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=)?(.+)/g;
	var embedUrl = "";

	// Pattern0 for people with private link
	if (pattern0.test(link)) {
		embedUrl = link.replace(pattern0, "https://player.vimeo.com/video/$1?controls=1&h=$2");
		if (autoplay) {
			embedUrl += "&autoplay=1";
			if (loop)
				embedUrl += "&loop=1";
		}
		else if (loop)
			embedUrl += "&loop=1";

		embedUrl = embedUrl+"&muted=1";
	} // Pattern1 for normal 
	else if (pattern1.test(link)) {
		embedUrl = link.replace(pattern1, "https://player.vimeo.com/video/$1?controls=1");
		if (autoplay) {
			embedUrl += "&autoplay=1";
			if (loop)
				embedUrl += "&loop=1";
		}
		else if (loop)
			embedUrl += "&loop=1";

		embedUrl = embedUrl+"&muted=1";
	}
	else if (pattern2.test(link)) {
		embedUrl = link.replace(pattern2, "https://www.youtube.com/embed/$1?rel=0&amp;showinfo=0&controls=1");
		if (autoplay)
			embedUrl += "&autoplay=1";
		if (loop) {
			//var id = this.getID(embedUrl);
			embedUrl += "&loop=1&rel=0&showinfo=0";
		}

		embedUrl = embedUrl+"&mute=1";
	}

	return embedUrl;
}